export const prefixCSSVars = (obj)=>Object.keys(obj).reduce((prev, cur)=>(prev[`--${cur}`] = obj[cur], prev), {});
